export default __webpack_public_path__ + "static/media/underline.4d0013c0.svg";